import type { ButtonProps } from '@eliadmin/core/src/components/ui/button';
import { FiCheck, FiTag, FiX } from 'react-icons/fi';

export const PRODUCT_CONFIG = {
  addToCartDialog: {
    continueShoppingButton: {
      variant: 'default',
    } as ButtonProps,
    addToCartButton: {
      variant: 'default',
    } as ButtonProps,
  },
  productPrice: {
    discountIcon: <FiTag className="h-4 w-4 stroke-[2px]" />,
  },
  productStock: {
    availableIcon: <FiCheck className="h-4 w-4" />,
    unavailableIcon: <FiX className="h-4 w-4" />,
  },
  availabilityLabel: {
    availableIcon: <FiCheck className="h-4 w-4" />,
    unavailableIcon: <FiX className="h-4 w-4" />,
  },
  notInStockDialog: {
    closeButton: {
      variant: 'default',
    } as ButtonProps,
  },
} as const;
